import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { NavLink, generatePath } from 'react-router-dom';
import { format } from 'date-fns';
import { useUrlParams, useConfig } from 'app/hooks';
import { SessionState, TicketsList } from 'app/components';
import { EntityContent } from 'app/components/Entity';
import { TitleDate } from '../styles';

const propTypes = {
  cinemaName: PropTypes.string.isRequired,
  tickets: PropTypes.arrayOf(PropTypes.object.isRequired).isRequired
};

const CinemaSessionView = ({ cinemaName, tickets }) => {
  const { routes } = useConfig();
  const { date, cinemaId } = useUrlParams('date', 'cinemaId');

  return (
    <Fragment>
      <SessionState />

      <TitleDate>{format(new Date(date), 'dd.MM.yyyy')}</TitleDate>

      <EntityContent isCinemaSession={false}>
        <NavLink
          to={{
            pathname: generatePath(routes.cinemaDetails.pattern, { id: cinemaId }),
            search: `?date=${date}`
          }}
          className="b-entity-content__title b-entity-content__link"
        >
          {cinemaName}
        </NavLink>
        <TicketsList tickets={tickets} />
      </EntityContent>
    </Fragment>
  );
};

CinemaSessionView.propTypes = propTypes;
export default CinemaSessionView;
